import { render, staticRenderFns } from "./BillOfLadingConfirmation.vue?vue&type=template&id=a4a9ba8e&scoped=true"
import script from "./BillOfLadingConfirmation.vue?vue&type=script&lang=js"
export * from "./BillOfLadingConfirmation.vue?vue&type=script&lang=js"
import style0 from "./BillOfLadingConfirmation.vue?vue&type=style&index=0&id=a4a9ba8e&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a9ba8e",
  null
  
)

export default component.exports